import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { VirtualEntryPointBanner } from '../../shared/common/virtual-entry-point-banner/virtual-entry-point-banner';

@Component({
    selector: 'virtual-entry-point-banner',
    templateUrl: './virtual-entry-point-banner.component.html',
    styleUrls: ['./virtual-entry-point-banner.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class VirtualEntryPointBannerComponent extends VirtualEntryPointBanner {}
